import * as React from "react";
const SvgScan = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M20 22v-7H4v7zM4 5h16V2H4z" }),
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2 7h20v6H2zm2 2h16v2H4z", clipRule: "evenodd" })));
export default SvgScan;
//# sourceMappingURL=Scan.js.map